import axios from 'axios';
import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT_LIST_SUCCESS = 'GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'GET_PRODUCT_LIST_FAILURE';

// Action Creators
export const getProductRequest = () => ({
  type: GET_PRODUCT_LIST,
});

export const getProductSuccess = (users) => ({
  type: GET_PRODUCT_LIST_SUCCESS,
  payload: users,
});

export const getProductFailure = (error) => ({
  type: GET_PRODUCT_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getProductList = (external, searchValue) => {
  return async (dispatch) => {
    dispatch(getProductRequest());
    try {
      let requestUrl = url?.recommendProductList;
      if (searchValue) {
        requestUrl += `?search_text=` + searchValue;
      }
      const response = await getMethodWithToken(requestUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getProductSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getProductFailure(error?.message));
    }
  };
};
